import { createContext, useContext, PropsWithChildren } from 'react';

export type EntrySourceType = string | undefined;

interface OptionContextValue {
  entry_source_type?: EntrySourceType;
}

const OptionContext = createContext<OptionContextValue | null>(null);

interface OptionProviderProps {
  entry_source_type?: EntrySourceType;
}

export function OptionProvider({ entry_source_type, children }: PropsWithChildren<OptionProviderProps>) {
  return <OptionContext.Provider value={{ entry_source_type }}>{children}</OptionContext.Provider>;
}

export function useOptionContext() {
  const context = useContext(OptionContext);

  if (!context) {
    return {
      entry_source_type: '',
    };
  }
  return context;
}
